import styled from '@emotion/styled';
import { mediaQuery } from 'src/assets/media-query-config';
import { FormWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';

export const TopEventsFormWrapper = styled(FormWrapper, { label: 'TopEventsFormWrapper' })`
    height: 100%;

    @media ${mediaQuery.xLargeDesktop} {
        max-height: 100%;
    }
`;

export const EventDataWrapper = styled('div', { label: 'EventDataWrapper' })`
    margin: 16px 0 32px 0;
`;
